import React, { useEffect, useRef, useState } from 'react';
import DsButton from '../../common/DsButton';
import GroupChatIconSelector from './GroupChatIconSelector';
import { groupChatIconChoiceFromFile } from './GroupChatIconPresetPicker';
import { loadGroupChatIconPreset } from '../../../api/adminGroupChat';
import { getGroupChatIconStyle } from './adminGroupChatPageHelpers';
import { IMAGE_UPLOAD_ACCEPT_ATTR } from '../../../utils/imageUploadCompatibility';
type Props = {
 thread: { thread_id: string; title?: string; icon_file?: string | null }; uploading: boolean; deleting: boolean;
 fileInputRef: React.RefObject<HTMLInputElement>; onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
 onDelete: () => unknown; onUpload: (iconFile: string, threadId?: string) => Promise<boolean>;
};
export default function GroupChatIconEditor({ thread, uploading, deleting, fileInputRef, onFileChange, onDelete, onUpload }: Props) {
 const active = useRef(true); const [photoPreparing, setPhotoPreparing] = useState(false);
 useEffect(() => { active.current = true; return () => { active.current = false; }; }, []);
 const busy = uploading || deleting || photoPreparing;
 return <GroupChatIconSelector key={`${thread.thread_id}:${thread.icon_file || ''}`} value={groupChatIconChoiceFromFile(thread.icon_file)} disabled={busy} imageStyle={getGroupChatIconStyle(thread)} onApply={async(choice)=>{
  await loadGroupChatIconPreset(choice.assetId);
  return active.current ? onUpload(choice.iconFile, thread.thread_id) : false;
 }}>
  <div className="group-chat-page__iconActions">
   <input ref={fileInputRef} type="file" accept={IMAGE_UPLOAD_ACCEPT_ATTR} className="group-chat-page__hiddenFileInput" onChange={async(event)=>{
    setPhotoPreparing(true); try { await onFileChange(event); } finally { if(active.current) setPhotoPreparing(false); }
   }} />
   <DsButton variant="secondary" appearance="text" disabled={busy} onClick={()=>fileInputRef.current?.click()}>画像を選択</DsButton>
   {thread.icon_file && <DsButton variant="danger" appearance="text" disabled={busy} onClick={onDelete}>アイコンを削除</DsButton>}
  </div>
 </GroupChatIconSelector>;
}
